import { render, staticRenderFns } from "./TypeVariants.vue?vue&type=template&id=284be306&scoped=true"
import script from "./TypeVariants.vue?vue&type=script&lang=js"
export * from "./TypeVariants.vue?vue&type=script&lang=js"
import style0 from "./TypeVariants.vue?vue&type=style&index=0&id=284be306&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284be306",
  null
  
)

export default component.exports